import { FormControlLabel, Checkbox as Check, FormControl, FormHelperText} from "@mui/material"

export default function Checkbox({label, value, onChange, required, error, helperText}){

    return <FormControl
        required={required ? true :  false}
        error={error ? true : false}
        component="fieldset"
        variant="standard"
    >

        <FormControlLabel 
            label={label}
            control={<Check checked={value ? true : false} size='small'/>}
            onChange={onChange}
        />

        <FormHelperText>{helperText}</FormHelperText>

    </FormControl>
} 